import { render, staticRenderFns } from "./MemberFamilyPanel.vue?vue&type=template&id=09673b2c"
import script from "./MemberFamilyPanel.vue?vue&type=script&lang=js"
export * from "./MemberFamilyPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports